import React, { useEffect, useState, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { Col, Row } from "antd";

import { mkaRules } from "./data/validation/validator";

import ApiNsi from "../../modules/api/Nsi";
import ApiRegistry from "../../api/Registry";

import { IButton, Popup } from "../../ui-kit";
import { ITab, ITabs } from "../../ui-kit/Tabs/Tabs";
import { useHandleForm } from "../../hooks/useHandleForm";
import ResourceFormData from "./resourceFormData";
import ResourceFormChoice from "./resourceFormChoice";

import nsi from "../../store/nsi";
import { authStore } from "../../store/authStore";
import { AddressInfo, IResourceFormTabsProps } from "./interface";
import defectCardsStore from "../../store/defectCards";
import { useStatusMessage } from "../../hooks/useStatusMessage";
import moment from "moment";

import {
  HEAT_SUPPLY_KEY,
  COLD_WATER_SUPPLY_KEY,
  GAS_COMMUNICATION_KEY,
  DRAINAGE_KEY,
  INCIDENT_STATUS_UPDATED,
  INCIDENT_STATUS_CLOSED,
  INCIDENT_STATUS_NEW,
} from "./constants";

import styles from "./DefectForm.module.scss";
import { isEmpty } from "lodash";
import { DEFECT_STATUS_CLOSED_ID, DEFECT_STATUS_NEW_ID, DEFECT_STATUS_UPDATED_ID } from "../DefectValidator/constants";

const ResourceFormTabs: React.FC<IResourceFormTabsProps> = observer(
  ({ isAddMode, userId, choices, defectData, isClose, isReadonly }) => {
    const [selectedResourceRSOs, setSelectedResourceRSOs] = useState([]);
    const { allOrgsView } = authStore;

    const {
      defectFormIsSending,
      defectInfo,
      saveDefectStatus,
      saveDefectError,
      saveDefectFileIsOpened,
    } = defectCardsStore;

    const [choice, setChoice] = useState(
      isAddMode
        ? choices[0]
        : choices?.find((c) => c.gridTypeId === defectData.gridTypeId),
    );
    const [fileImage, setFileImage] = useState(
      isAddMode ? [] : toJS(defectData.filesIds),
    );
    const [addressInfo, setAddressInfo] = useState<AddressInfo>(null);
    const [districtInfo, setDistrictInfo] = useState(null);

    const handleForm = useHandleForm(
      isAddMode
        ? choice?.addSchema
        : isClose
        ? choice?.closeSchema
        : !isAddMode && !isClose && choice?.addSchema,
      isAddMode ? choice?.initialValues : choices && defectData,
      {},
    );
    const {
      setValue,
      watchAllField,
      handleSubmit,
      reset,
      errors,
      clearErrors,
    } = handleForm;

    useEffect(() => {
      if (defectInfo && !addressInfo) {
        setAddressInfo({
          id: defectInfo.addressGuid,
          label: defectInfo.addressText,
          value: defectInfo.addressText,
          lat: defectInfo.lat,
          lon: defectInfo.lng,
        });
      }
    }, [defectInfo]);

    useEffect(() => {
      reset(isAddMode ? choice?.initialValues : defectData);
      ApiRegistry.getOrganizations(choice?.gridTypeId).then((response) => {
        setSelectedResourceRSOs(response.data);
      });
    }, [choice]);

    useEffect(() => {
      if (watchAllField.gridTypeId) {
        switch (watchAllField.gridTypeId) {
          case 1:
            return setValue("mkaUtilitiesSectorId", 2);
          case 2:
            return setValue("mkaUtilitiesSectorId", 3);
          case 3:
            return setValue("mkaUtilitiesSectorId", 5);
          case 4:
            return setValue("mkaUtilitiesSectorId", 6);
          case 5:
            return setValue("mkaUtilitiesSectorId", 4);
          case 6:
            return setValue("mkaUtilitiesSectorId", 1);
          default:
            setValue("mkaUtilitiesSectorId", 0);
        }
      }
    }, [watchAllField.gridTypeId]);

    useEffect(() => {
      clearErrors("addressGuid");
      setValue("addressGuid", addressInfo?.id);
    }, [addressInfo]);

    useEffect(() => {
      clearErrors("districtId");
      if (districtInfo) {
        setValue("districtId", districtArr[0]?.id);
      } else {
        setValue("districtId", watchAllField.districtId);
      }
    }, [districtInfo]);

    useEffect(() => {
      if (watchAllField.addressGuid) {
        ApiNsi.getAddressGuids(watchAllField.addressGuid)
          .then((response) => {
            setDistrictInfo(response.data.district);
          })
          .catch((err) => console.log(err));
      }
    }, [watchAllField.addressGuid]);

    useEffect(() => {
      if (/*defectNotify === true || */ allOrgsView === true) return;
      if (!authStore.userProfile.organizationId) return;
      const org = Number(localStorage.getItem("userOrgId"));
      setValue("organizationId", org);
    }, [
      choices,
      authStore.userProfile.organizationId,
      watchAllField.organizationId,
    ]);

    useEffect(() => {
      if (fileImage.length > 0) {
        setValue("files", fileImage);
      }
    }, [fileImage]);

    const districtsData = toJS(nsi.districts);
    const districtArr =
      districtsData && districtsData.filter((i) => i.title === districtInfo);

    const onChangeImage = (fileList) => {
      setFileImage(fileList);
    };

    const history = useHistory();

    const arrayKeysMkaRules = Object.keys(mkaRules);
    const isResourceFormDataError =
      !isEmpty(errors) &&
      Object.keys(errors).some((key) => !arrayKeysMkaRules.includes(key));

    useEffect(() => {
      console.log(
        (watchAllField.livingBuildings
          ? Number(watchAllField.livingBuildings)
          : 0) +
          (watchAllField.hospitalBuildings
            ? Number(watchAllField.hospitalBuildings)
            : 0) +
          (watchAllField.childrenBuildings
            ? Number(watchAllField.childrenBuildings)
            : 0) +
          (watchAllField.buildings ? Number(watchAllField.buildings) : 0),
        "-----sum0",
      );
      if (
        [
          HEAT_SUPPLY_KEY,
          COLD_WATER_SUPPLY_KEY,
          GAS_COMMUNICATION_KEY,
          DRAINAGE_KEY,
        ].includes(choice?.id)
      ) {
        console.log(
          (watchAllField.livingBuildings
            ? Number(watchAllField.livingBuildings)
            : 0) +
            (watchAllField.hospitalBuildings
              ? Number(watchAllField.hospitalBuildings)
              : 0) +
            (watchAllField.childrenBuildings
              ? Number(watchAllField.childrenBuildings)
              : 0) +
            (watchAllField.buildings ? Number(watchAllField.buildings) : 0),
          "-----sum",
        );
        setValue(
          "overBuildings",
          (watchAllField.livingBuildings
            ? Number(watchAllField.livingBuildings)
            : 0) +
            (watchAllField.hospitalBuildings
              ? Number(watchAllField.hospitalBuildings)
              : 0) +
            (watchAllField.childrenBuildings
              ? Number(watchAllField.childrenBuildings)
              : 0) +
            (watchAllField.buildings ? Number(watchAllField.buildings) : 0),
        );
      }
    }, [
      watchAllField.livingBuildings,
      watchAllField.hospitalBuildings,
      watchAllField.childrenBuildings,
      watchAllField.buildings,
    ]);

    const initialTabs: Array<ITab> = [
      {
        name: "Данные для сит. управления",
        key: "1",
        forceRender: true,
        isError: isResourceFormDataError,
        editable: false,
        content: choice ? (
          <ResourceFormData
            formId={choice?.id}
            isAddMode={isAddMode}
            isReadonly={isReadonly}
            isClose={isClose}
            onChangeImage={onChangeImage}
            setAddressInfo={setAddressInfo}
            data={defectData}
            RSOList={selectedResourceRSOs}
            {...handleForm}
          />
        ) : (
          "Недостаточно прав на редактирование"
        ),
      },
    ];

    useStatusMessage(saveDefectStatus);

    const onSubmit = (values) => {
      const concatDateTime = (date, time = "") => {
        if (!moment(date).isValid()) return "";
        const currentDate = moment(date).format("YYYY-MM-DD");
        const currentTime = time && time.length === 5 ? `T${time}:00` : "";
        return currentDate && currentTime
          ? `${currentDate}${currentTime}`
          : currentDate || "";
      };

      const times = {
        dateTimeDisable: "timeDisable",
        dateTimeEnable: "timeEnable",
        dateTimePlanned: "gasPlannedTime",
        dateTimeWorkStarted: "lightingWorkStartedTime",
      };
      for (const [key, val] of Object.entries(times)) {
        if (values?.[key] && values?.[val]) {
          values[key] = concatDateTime(values[key], values[val]);
        }
      }
      const {
        files,
        mkaDecisionStatusId,
        fullOfMkdCount,
        partialOfMkdCount,
        connectedOfMkdCount,
        municipalityText,
        mkaUtilitiesSectorId,
        incidentDescription,
        parentId,
        mkaTechonologicalProcessStageId,
        mkaObjectKindId,
        mkaObjectType,
        mkaObjectName,
        mkaIncidentTypeId,
        deadCount,
        affectedCount,
        weather,
        fullFact,
        fullListOfLocation,
        fullListOfObjects,
        fullOfSocialObjectsCount,
        fullListOfMkd,
        fullOfMkdPplCount,
        fullOfPrivateHousesCount,
        fullOfPrivateHousesPplCount,
        fullListOfObjectsOther,
        partialFact,
        partialListOfLocation,
        partialListOfObjects,
        partialOfSocialObjectsCount,
        partialListOfMkd,
        partialOfMkdPplCount,
        partialOfPrivateHousesCount,
        partialOfPrivateHousesPplCount,
        partialListOfObjectsOther,
        connectedFact,
        connectedListOfCommunalServices,
        connectedListOfLocation,
        connectedListOfObjects,
        connectedOfSocialObjectsCount,
        connectedListOfMkd,
        connectedOfMkdPplCount,
        connectedOfPrivateHousesCount,
        connectedOfPrivateHousesPplCount,
        connectedListOfObjectsOther,
        objectOwnerName,
        operatingOrganizationName,
        planResponsibles,
        additionalInformation,
        operationalInformationSource,
        addressDisconnexionList,
        addressAreaId,
        ...otherData
      } = values;

      const defect = {
        incidentStatusId: isClose
          ? DEFECT_STATUS_CLOSED_ID
          : DEFECT_STATUS_UPDATED_ID,
        organizationId: watchAllField.organizationId
          ? watchAllField.organizationId
          : userId,
        files: files,
        mkaDto: {
          mkaDecisionStatusId,
          fullOfMkdCount,
          partialOfMkdCount,
          connectedOfMkdCount,
          municipalityText,
          mkaUtilitiesSectorId,
          incidentDescription,
          parentId: parentId === "" ? null : parentId,
          mkaTechonologicalProcessStageId,
          mkaObjectKindId,
          mkaObjectType,
          mkaObjectName,
          mkaIncidentTypeId,
          deadCount,
          affectedCount,
          weather,
          fullFact,
          fullListOfLocation,
          fullListOfObjects,
          fullOfSocialObjectsCount,
          fullListOfMkd,
          fullOfMkdPplCount,
          fullOfPrivateHousesCount,
          fullOfPrivateHousesPplCount,
          fullListOfObjectsOther,
          partialFact,
          partialListOfLocation,
          partialListOfObjects,
          partialOfSocialObjectsCount,
          partialListOfMkd,
          partialOfMkdPplCount,
          partialOfPrivateHousesCount,
          partialOfPrivateHousesPplCount,
          partialListOfObjectsOther,
          connectedFact,
          connectedListOfCommunalServices,
          connectedListOfLocation,
          connectedListOfObjects,
          connectedOfSocialObjectsCount,
          connectedListOfMkd,
          connectedOfMkdPplCount,
          connectedOfPrivateHousesCount,
          connectedOfPrivateHousesPplCount,
          connectedListOfObjectsOther,
          objectOwnerName,
          operatingOrganizationName,
          planResponsibles,
          additionalInformation,
          operationalInformationSource,
          addressAreaId,
        },
        ...otherData,
        addressDisconnexion: addressDisconnexionList
          ?.map(({ guid }) => guid)
          .filter((guid) => guid)
          .join(","),
      };

      const newDefect = {
        id: isAddMode ? 0 : defectData.id,
        incidentStatusId: isAddMode
          ? DEFECT_STATUS_NEW_ID
          : isClose
          ? DEFECT_STATUS_CLOSED_ID
          : DEFECT_STATUS_UPDATED_ID,
        organizationId: watchAllField.organizationId
          ? watchAllField.organizationId
          : userId,
        files: files,
        mkaDto: {
          mkaDecisionStatusId,
          fullOfMkdCount,
          partialOfMkdCount,
          connectedOfMkdCount,
          municipalityText,
          mkaUtilitiesSectorId,
          incidentDescription,
          parentId,
          mkaTechonologicalProcessStageId,
          mkaObjectKindId,
          mkaObjectType,
          mkaObjectName,
          mkaIncidentTypeId,
          deadCount,
          affectedCount,
          weather,
          fullFact,
          fullListOfLocation,
          fullListOfObjects,
          fullOfSocialObjectsCount,
          fullListOfMkd,
          fullOfMkdPplCount,
          fullOfPrivateHousesCount,
          fullOfPrivateHousesPplCount,
          fullListOfObjectsOther,
          partialFact,
          partialListOfLocation,
          partialListOfObjects,
          partialOfSocialObjectsCount,
          partialListOfMkd,
          partialOfMkdPplCount,
          partialOfPrivateHousesCount,
          partialOfPrivateHousesPplCount,
          partialListOfObjectsOther,
          connectedFact,
          connectedListOfCommunalServices,
          connectedListOfLocation,
          connectedListOfObjects,
          connectedOfSocialObjectsCount,
          connectedListOfMkd,
          connectedOfMkdPplCount,
          connectedOfPrivateHousesCount,
          connectedOfPrivateHousesPplCount,
          connectedListOfObjectsOther,
          objectOwnerName,
          operatingOrganizationName,
          planResponsibles,
          additionalInformation,
          operationalInformationSource,
          addressAreaId,
        },
        ...otherData,
        addressDisconnexion: addressDisconnexionList
          ?.map(({ guid }) => guid)
          .join(","),
      };

      if (isClose) {
        if (
          defect.discharge == null &&
          (defect.gridTypeId == COLD_WATER_SUPPLY_KEY ||
            defect.gridTypeId == DRAINAGE_KEY)
        ) {
          defect.discharge = false;
        }
      }

      defectCardsStore.saveDefect(
        isAddMode ? newDefect : defect,
        isAddMode ? 0 : defectData.id,
        history,
      );
    };

    const resetChanges = () => {
      history.push("/sp/reestr");
    };

    const handleCloseSaveDefectPopup = () => {
      defectCardsStore.closeSaveDefect();
    };

    return (
      <Fragment>
        <div className={styles.defectForm}>
          {choices.length > 1 && isAddMode && (
            <ResourceFormChoice
              choice={choice}
              setChoice={setChoice}
              choices={choices}
            />
          )}
          <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
            <ITabs isErrorTabs tabs={initialTabs} />
            <div className={styles.defectFormFooter}>
              <Row gutter={8}>
                <Col span={12}>
                  <IButton
                    className={styles.btn}
                    type="submit"
                    disabled={defectFormIsSending.value || isReadonly}
                  >
                    Сохранить
                  </IButton>
                </Col>
                <Col span={12}>
                  <IButton
                    className={styles.btn}
                    variant="outlined"
                    onClick={resetChanges}
                    disabled={defectFormIsSending.value}
                  >
                    Отмена
                  </IButton>
                </Col>
              </Row>
            </div>
          </form>
        </div>
        <Popup
          open={saveDefectFileIsOpened.value}
          onClose={handleCloseSaveDefectPopup}
          title={"Ошибка создания дефекта"}
          className={styles.saveDefectPopup}
        >
          <div className={styles.saveDefectContainer}>{saveDefectError}</div>
        </Popup>
      </Fragment>
    );
  },
);

export default ResourceFormTabs;
